<!-- 文件上传[可拖拽] -->
<template>
  <uploader class="my-uploader-css" @file-added="getFileName">
    <!-- 拖拽区域插槽 -->
    <uploader-drop>
      <div @click="upfile">
        <slot></slot>
      </div>
    </uploader-drop>
    <uploader-btn style="display: none;" ref="upbtn" >Upload File</uploader-btn>
  </uploader>
</template>
<script>
export default {
  name:"file-blank",
  props:{
    error: {
      type: Boolean,
      default: false,
    },
    typeFilter:{
      type: Array,
      default: () => {
        return []
      },
    },
    // sizeFilter_min:{// 文件大小(最小要求, MB)
    //   type: Number,
    //   default: 0,
    // },
    sizeFilter_max:{// 文件大小(最大要求, MB)
      type: Number,
      default: 0,
    },
    nameUseTime:{ // 用时间戳做文件名
      type:Boolean,
      default: false,
    },
  },
  data(){
    return {
      // childValue: this.value,
    }
  },
  methods:{
    upfile(){
      this.$refs.upbtn.$el.click()
    },
    getFileName (file) { // 获取文件名
      if(!file){
        return
      }
      const files = [file.file]

      if (!files || files.length === 0) {
        return
      }

      if(this.typeFilter.length > 0){
        const typeName = files[0].name.split(".").pop();
        if(!files[0].name.includes(".") || !this.typeFilter.includes(typeName)){
          this.$errorMsg(this.$I18n("error_file_type").replace("XXX", this.typeFilter.join("','")))
          return files[0].name
        }
      }
      if(this.sizeFilter_max > 0 && files[0].size > this.sizeFilter_max * 1024 * 1024){
        this.$errorMsg(this.$I18n("error_file_size_b").replace("XXX", this.sizeFilter_max))
        return files[0].name
      }
      if (files.length > 1) {
        return this.getMultipleName(files)
      }

      if (files.length === 1) {
        this.$emit("change","",files[0].name);
        var fileObj = files[0];
        if(this.nameUseTime){
          fileObj = new File(
            [files[0]],
            new Date().getTime()+ "." +files[0].name.split(".").pop(),
            {type: files[0].type}
          )
        }
        this.$api.uploadFile_PUT({
          file: fileObj, 
        })
          .then(this.$Then(res => {
            this.$emit("change",res.data.get_url, fileObj.name);
          }))
          .catch(this.$Catch(this.$I18n("file_error"), () => {
            this.$emit("change","", fileObj.name);
          }))
        return fileObj.name
      }

      return null
    },
  },
}
</script>
<style lang="css" scoped>
  .my-uploader-css /deep/ .uploader-drop{
    background: unset;
    border-color: #DCDFE6;
    border-radius: 5px;
    width: 338px;
    cursor: pointer;
  }
</style>